import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Newsletter from './Newsletter';
import { purifier } from '../../utils/dom';
import { translate, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Footer.scss';

class Footer extends Component {
	render() {
		const { properties, setup, footer, navigation } = this.props;
		if (properties.siteInitiated === false || properties.siteClosed === true) return null;

		return (
			<div className={s.footer} style={{ backgroundColor: footer.backgroundColor }}>
				<div className={s.footer_top}>
					<h5 className={s.footer_top_title}>{ translate(setup, footer.introTitle) }</h5>
					<p>{ translate(setup, footer.intro) }</p>
				</div>
				<div className={s.footer_inner}>
					<div className={[s.footer_inner_column, s.footer_inner_column__double].join(' ')}>
						<h5 className={s.footer_inner_column_header}>{ translate(setup, footer.newsletterTitle) }</h5>
						<Newsletter />
						<div className={s.footer_inner_column_icons}>
							{
								footer.socialMediaIcons && footer.socialMediaIcons.map((item) => {
									if (item.link.indexOf(/(http|mailto|tel)/) === -1) {
										return <a href={item.link} key={urlify(item.icon.url)} target="_blank" rel="noopener noreferrer nofollow"><img src={item.icon.url} alt={item.icon.alt} /></a>;
									}
									return <Link to={prefix(setup, item.link)} key={urlify(item.icon.url)} rel="nofollow"><img src={item.icon.url} alt={item.icon.alt} /></Link>;
								})
							}
						</div>
					</div>
					<div className={s.footer_inner_column}>
						<h5 className={s.footer_inner_column_header}>{ translate(setup, footer.contactTitle) }</h5>
						<div className={s.footer_inner_column_links} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, footer.contact)) }} />
					</div>
					<div className={s.footer_inner_column}>
						<h5 className={s.footer_inner_column_header}>{ translate(setup, footer.aboutTitle) }</h5>
						<div className={s.footer_inner_column_links}>
							{
								navigation.about && navigation.about.map((link) => {
									const uri = translate(setup, link, 'uri');
									if (uri.indexOf(/(http|mailto|tel)/) !== -1) {
										return <a className={s.footer_inner_column_link} href={uri} key={uri} target="_blank" rel="noopener noreferrer nofollow"><span>{ translate(setup, link, 'title') }</span></a>;
									}
									return <Link className={s.footer_inner_column_link} to={prefix(setup, uri)} key={uri}><span>{ translate(setup, link, 'title') }</span></Link>;
								})
							}
						</div>
						<h5 className={s.footer_inner_column_header}>{ translate(setup, footer.shopTitle) }</h5>
						<div className={s.footer_inner_column_links}>
							{
								navigation.shop && navigation.shop.map((link) => {
									const uri = translate(setup, link, 'uri');
									if (uri.indexOf(/(http|mailto|tel)/) !== -1) {
										return <a className={s.footer_inner_column_link} href={uri} key={uri} target="_blank" rel="noopener noreferrer nofollow"><span>{ translate(setup, link, 'title') }</span></a>;
									}
									return <Link className={s.footer_inner_column_link} to={prefix(setup, uri)} key={uri}><span>{ translate(setup, link, 'title') }</span></Link>;
								})
							}
						</div>
					</div>
					<div className={s.footer_inner_column}>
						<h5 className={s.footer_inner_column_header}>{ translate(setup, footer.supportTitle) }</h5>
						<div className={s.footer_inner_column_links}>
							{
								navigation.assistance && navigation.assistance.map((link) => {
									const uri = translate(setup, link, 'uri');
									if (uri.indexOf(/(http|mailto|tel)/) !== -1) {
										return <a className={s.footer_inner_column_link} href={uri} key={uri} target="_blank" rel="noopener noreferrer nofollow"><span>{ translate(setup, link, 'title') }</span></a>;
									}
									return <Link className={s.footer_inner_column_link} to={prefix(setup, uri)} key={uri}><span>{ translate(setup, link, 'title') }</span></Link>;
								})
							}
						</div>
					</div>
				</div>
				<div className={s.footer_services}>
					{
						footer.trustLogos && footer.trustLogos.map((item) => (
							<img key={item.key} className={s.footer_service} src={item.logo.url} alt={item.logo.alt} />
						))
					}
				</div>
			</div>
		);
	}
}

const mapState = ({ environment }) => {
	const { properties, setup, footer, navigation } = environment;
	return { properties, setup, footer, navigation };
};

export default connect(mapState)(Footer);
